var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C17.5252 2 22 6.47478 22 12C22 17.5252 17.5252 22 12 22C6.47478 22 2 17.5252 2 12C2 6.47478 6.47478 2 12 2ZM5.59961 14.5C6.59965 17.0626 9.08738 18.875 12 18.875C14.9126 18.875 17.4003 17.0626 18.4004 14.5H16.3125C15.4375 15.9876 13.8501 17 12 17C10.1499 17 8.56254 15.9876 7.6875 14.5H5.59961ZM7.625 7C6.58942 7 5.75 7.83942 5.75 8.875C5.75007 9.91052 6.58947 10.75 7.625 10.75C8.66045 10.7499 9.49993 9.91046 9.5 8.875C9.5 7.83948 8.66049 7.0001 7.625 7ZM16.375 7C15.3395 7.0001 14.5 7.83948 14.5 8.875C14.5001 9.91046 15.3395 10.7499 16.375 10.75C17.4105 10.75 18.2499 9.91052 18.25 8.875C18.25 7.83942 17.4106 7 16.375 7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 4.28571H20.2857V6H19.7143V4.28571H18V3.71429H19.7143V2H20.2857V3.71429H22V4.28571Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.954388f52820acaf0ed692ecf8b5a653.svg";
export { ForwardRef as ReactComponent };